import { qnPrimary } from '../themes/_palette';

export const MuiTreeItem = {
    styleOverrides: {
        content: {
            height: 40,
            borderRadius: 8,
            "&:hover, &.Mui-focused": {
                backgroundColor: 'var(--mui-palette-secondary-main)'
            }
        },
        iconContainer: {
            marginRight: 16,
            color: '#52575C'
        },
        label: {
            "& .MuiTypography-root": {
                fontSize: '0.875rem'
            }
        }
    }
}
